import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, of, Subscription, switchMap, tap } from 'rxjs';
import { Page, Pageable } from 'src/app/utils/pageable';
import { SpinnerService } from 'src/app/utils/services/spinner.service';
import { ProductContextService } from 'src/app/col/services/product-context.service';
import { NativeServiceApiProvider } from 'src/app/services/native-api-provider.service';
import { AuthorizationServiceProvider } from 'src/app/auth_profile/services/authorization-service.provider';
import * as LessonsV3 from '../../../model/v3/lessons';

@Component({
    selector: 'app-purchase-history',
    templateUrl: './purchase-history.component.html',
    styleUrls: ['./purchase-history.component.scss'],
    standalone: false
})
export class PurchaseHistoryComponent implements OnInit, OnDestroy {
  pageable: Pageable = Pageable.of(0, 5, ['lb.date,desc']);
  results: Page<LessonsV3.LessonBundle>;
  _langCode: string;
  private _studentId: number;
  private schoolId: number;
  isLoading = true;
  productContextSubscription: Subscription;

  @Input() set studentId(id: number) {
    this._studentId = id;
  }
  @Input() set langCode(langCode: string) {
    this._langCode = langCode;
    this.reload();
  }
  constructor(
    private spinner: SpinnerService,
    private provider: NativeServiceApiProvider,
    private auth: AuthorizationServiceProvider,
    private productContextService: ProductContextService) {}

  ngOnInit(): void {
    this.auth.getAuthDetailsService().pipe(
      switchMap((api) => api.getSelfSchoolId()),
      tap((schoolId) => {
        this.schoolId = schoolId;
      }),
      switchMap(() => this.initQuery())
    ).subscribe();
    this.productContextSubscription = this.productContextService.productContext.pipe(
      switchMap(() => this.initQuery())
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.productContextSubscription?.unsubscribe();
  }

  private reload(): void {
    this.initQuery().subscribe();
  }

  private initQuery(): Observable<Page<LessonsV3.LessonBundle>> {
    return this.spinner
      .trace<Page<LessonsV3.LessonBundle>>(this.getAvailableBundles())
      .pipe(
        tap((result) => {
          this.results = result;
          this.isLoading = false;
        })
      );
  }

  private getAvailableBundles(): Observable<Page<LessonsV3.LessonBundle>> {
    if (!this.schoolId || !this._studentId) {
      return of(null);
    }
    return this.provider.colV3().pipe(
      switchMap((api) =>
        api.getStudentBundles(
          this.schoolId,
          this._studentId,
          this.pageable,
          this._langCode,
          null
        )
      )
    );
  }

  getResults() {
    return this.results?.content || [];
  }

  onPageChange($event) {
    this.pageable = $event;
    this.reload();
  }
}
